export default __webpack_public_path__ + "locales/tr/ChangeUserTypeDialog.json?hash=2f1b28a12d694e5e979c4294c272f72d";